/*
 * @Description:
 * @Date: 2024-12-13 17:06:19
 */
import {
  useInputColumn,
  useSelectColumn,
  useDatePickerColumn
} from 'xrk-components';
import {
  ORDER_PRICE_TYPE,
  PAY_TYPE,
  ORDER_PAY_STATUS,
  TERMINAL_TYPE,
  ORDER_PAY_STATUS_PAY_SUCCESS
} from '../constants/index';
import { PLATFORM_IS_FEIGON } from '@/config';
import { PAY_PASSAGEWAY_MAPPING } from '@/common/constants/bank/index';
import { taxPatternMapping } from '@constants/project';

/** 手机号 */
export const phoneSearch = useInputColumn({
  label: '手机号',
  prop: 'phone',
  type: 'input',
  config: {
    type: 'tel',
    placeholder: '请输入手机号'
  }
});

/** 订单编号 */
export const orderNoSearch = useInputColumn({
  prop: 'orderNo',
  type: 'input',
  label: '订单编号',
  config: {
    placeholder: '请输入'
  }
});

/** 个体工商户名称 */
export const individualNameSearch = useInputColumn({
  prop: 'individualName',
  type: 'input',
  label: '个体工商户名称',
  config: {
    placeholder: '请输入'
  }
});

/** 所属园区 */
export const parkNameSearch = useInputColumn({
  prop: 'belongingPark',
  type: 'input',
  label: '所属园区',
  config: {
    placeholder: '请输入'
  }
});

/** 终端服务人员 */
export const fullNameSearch = useInputColumn({
  prop: 'userName',
  type: 'input',
  label: '终端服务人员',
  config: {
    placeholder: '请输入'
  }
});

/** 结算单号 */
export const industryFenpeiCodeSearch = useInputColumn({
  prop: 'industryFenpeiCode',
  type: 'input',
  label: '结算单号',
  config: {
    placeholder: '请输入'
  }
});

/** 项目名称 */
export const projectNameSearch = useInputColumn({
  prop: 'projectName',
  type: 'input',
  label: '项目名称',
  config: {
    placeholder: '请输入'
  }
});

/** 项目编码 */
export const projectNoSearch = useInputColumn({
  prop: 'projectCode',
  type: 'input',
  label: '项目编码',
  config: {
    placeholder: '请输入'
  }
});

/** 交易结构 */
export const taxCollectionPatternSearch = useSelectColumn({
  prop: 'taxPattern',
  label: '交易结构',
  config: {
    placeholder: '请选择',
    options: taxPatternMapping
  }
});

/** 终端类型 */
export const terminalTypeSearch = useSelectColumn({
  prop: 'terminalType',
  label: '终端类型',
  config: {
    placeholder: '请选择',
    options: TERMINAL_TYPE
  }
});

/** 工业名称 */
export const entpNameSearch = useInputColumn({
  prop: 'industryName',
  type: 'input',
  label: '工业名称',
  config: {
    placeholder: '请输入'
  }
});

/** 供应商名称 */
export const supplierNameSearch = useInputColumn({
  prop: 'supplierName',
  type: 'input',
  label: '供应商名称',
  config: {
    placeholder: '请输入'
  }
});

/** 订单类型 */
export const orderTypeSearch = useSelectColumn({
  prop: 'orderType',
  label: '订单类型',
  config: {
    placeholder: '请选择',
    options: ((): any => {
      // 如果是飞冠则移除2、3（平台服务费和商务服务费）
      if (!PLATFORM_IS_FEIGON) return ORDER_PRICE_TYPE;
      return Object.keys(ORDER_PRICE_TYPE).reduce((acc: any, key) => {
        const item = (ORDER_PRICE_TYPE as any)[key];
        if (item && item.value !== 2 && item.value !== 3) {
          acc[key] = item;
        }
        return acc;
      }, {});
    })()
  }
});

/** 订单生成时间 */
export const orderTimeAtSearch = useDatePickerColumn({
  prop: 'orderTime',
  label: '订单生成时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 订单完结时间 */
export const orderFinishTimeSearch = useDatePickerColumn({
  prop: 'orderFinishTime',
  label: '订单完结时间',
  style: {
    width: '270px'
  },
  config: {
    type: 'daterange'
  }
});

/** 支付方式 */
export const payTypeSearch = useSelectColumn({
  prop: 'payType',
  label: '支付方式',
  config: {
    placeholder: '请选择',
    options: PAY_TYPE
  }
});

/** 支付通道 */
export const payPassagewayNameSearch = useSelectColumn({
  prop: 'payPassagewayCode',
  label: '支付通道',
  config: {
    placeholder: '请选择',
    options: PAY_PASSAGEWAY_MAPPING
  }
});

/** 支付状态 */
export const payStatusSearch = useSelectColumn({
  prop: 'payStatus',
  label: '支付状态',
  config: {
    placeholder: '请选择',
    options: ORDER_PAY_STATUS
  }
});

/** 供应商支付状态 */
export const supplierPayStatusSearch = useSelectColumn({
  prop: 'supplierPayStatus',
  label: '供应商支付状态',
  config: {
    placeholder: '请选择',
    options: ORDER_PAY_STATUS_PAY_SUCCESS
  }
});
